<template>
    <div id="new-busi-form">
        <div class="new-head">
            <div class="head-left">
                <img src="/images/titleLogo.png" />
                <div class="head-left-info">
                    <!-- <svg-icon style="font-size:44px" icon-class="wf_form" /> -->
                    <div class="head-title">{{ `人事档案 > 档案信息` }}</div>
                    <div class="header-tab">
                        <div class="tab-item" :class="activeTabId === 'ArchiveInfo' ? 'active' : ''" @click="handleHeaderTabClick('ArchiveInfo')">档案信息</div>
                        <div class="tab-item" :class="activeTabId === 'AppointmnetInfos' ? 'active' : ''" @click="handleHeaderTabClick('AppointmnetInfos')">任职信息</div>
                        <div class="tab-item" :class="activeTabId === 'TransferInfo' ? 'active' : ''" @click="handleHeaderTabClick('TransferInfo')">调离信息</div>
                        <div class="tab-item" :class="activeTabId === 'CertificatesInfo' ? 'active' : ''" @click="handleHeaderTabClick('CertificatesInfo')">相关学历及职业技能证书</div>
                        <!-- <div class="tab-item" :class="activeTabId === 'ExamineRecord' ? 'active' : ''" @click="handleHeaderTabClick('ExamineRecord')">考核记录</div> -->
                        <div class="tab-item" :class="activeTabId === 'workExperiences' ? 'active' : ''" @click="handleHeaderTabClick('workExperiences')">工作成长记录</div>
                        <div class="tab-item" :class="activeTabId === 'FamilyMembers' ? 'active' : ''" @click="handleHeaderTabClick('FamilyMembers')">家庭成员</div>
                        <div class="tab-item" :class="activeTabId === 'ArchiveChangeInfo' ? 'active' : ''" @click="handleHeaderTabClick('ArchiveChangeInfo')">变动信息</div>
                        <div class="tab-item" :class="activeTabId === 'ArchiveConInfos' ? 'active' : ''" @click="handleHeaderTabClick('ArchiveConInfos')">人事合同</div>
                        <div v-if="vo.passenger.wageInfo && vo.passenger.wageInfo.length > 0" class="tab-item" :class="activeTabId === 'WageInfo' ? 'active' : ''" @click="handleHeaderTabClick('WageInfo')">工资信息</div>
                        <div v-if="vo.passenger.vacateInfo && vo.passenger.vacateInfo.length > 0" class="tab-item" :class="activeTabId === 'VacateInfo' ? 'active' : ''" @click="handleHeaderTabClick('VacateInfo')">请休假情况</div>
                    </div>
                </div>
            </div>

            <div class="head-right">
                <el-button @click="close">
                    <svg-icon style="color: red; margin-right: 5px" icon-class="glyphicon-off" />
                    关闭
                </el-button>
                <el-button v-show="canEdit === 1 && formType === 'update'" icon="el-icon-close" @click="edit(0)">取消</el-button>
                <el-button v-show="canEdit === 1 && noEdit !== 'true'" :disabled="btnDisabled" @click="submit(true)">
                    <svg-icon style="margin-right: 5px" icon-class="save" />
                    保存关闭
                </el-button>
                <el-button v-show="canEdit === 1 && noEdit !== 'true'" type="primary" :disabled="btnDisabled" @click="submit(false)">
                    <svg-icon style="margin-right: 5px" icon-class="save" />
                    保存
                </el-button>
                <el-button v-show="canEdit === 0 && noEdit !== 'true'" icon="el-icon-edit" type="primary" @click="edit(1)">修改</el-button>
            </div>
        </div>

        <div v-if="show" id="busiComponents" class="busi-box">
            <div class="busi-content" style="width: 100%">
                <div class="title-info">{{ busiInfo }}</div>
                <div class="busi-components" style="width: 100%">
                    <!-- 五个组件放在这 -->
                    <ArchiveInfo id="ArchiveInfo" ref="ArchiveInfo" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ArchiveInfo>
                    <AppointmnetInfos id="AppointmnetInfos" ref="AppointmnetInfos" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></AppointmnetInfos>
                    <TransferInfo id="TransferInfo" ref="TransferInfo" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></TransferInfo>
                    <CertificatesInfo id="CertificatesInfo" ref="CertificatesInfo" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></CertificatesInfo>
                    <ExamineRecord id="ExamineRecord" ref="ExamineRecord" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ExamineRecord>
                    <workExperiences id="workExperiences" ref="workExperiences" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></workExperiences>
                    <FamilyMembers id="FamilyMembers" ref="FamilyMembers" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></FamilyMembers>
                    <ArchiveChangeInfo id="ArchiveChangeInfo" ref="ArchiveChangeInfo" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ArchiveChangeInfo>
                    <ArchiveConInfos id="ArchiveConInfos" ref="ArchiveConInfos" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></ArchiveConInfos>
                    <WageInfo v-if="vo.passenger.wageInfo && vo.passenger.wageInfo.length > 0" id="WageInfo" ref="WageInfo" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></WageInfo>
                    <VacateInfo v-if="vo.passenger.vacateInfo && vo.passenger.vacateInfo.length > 0" id="VacateInfo" ref="VacateInfo" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></VacateInfo>
                    <!-- <renzhi-info-form id="renzhiInfo" ref="renzhiInfoRef" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></renzhi-info-form>
          <work-experience-form id="workExperience" ref="workExperienceRef" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></work-experience-form>
          <change-info-list id="changedInfo" ref="changedInfoRef" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></change-info-list>
          <other-info-form id="otherInfo" ref="otherInfoRef" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" class="table-gap"></other-info-form> -->

                    <!-- <busiFormW ref="person" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo"></busiFormW> -->
                    <!-- <otherInfo v-if="title==='人事档案'" style="margin-top:30px" :vo="vo" :can-edit="canEdit" :form-type="formType" :file-list="fileList" />
          <HyglNewDialogTabInfo v-if="busiInfo==='会议信息'" :vo="vo" style="margin-top:30px" />
          <busiInner ref="inner" style="margin-top:30px" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" />
          <components is="busiComponent" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" style="margin-top:30px" />
          <components is="otherComponent" :vo="vo" :can-edit="canEdit" :module-info="moduleInfo" style="margin-top:30px" /> -->
                    <!-- </busic-info-form></div> -->
                </div>
            </div>
            <!-- 通用弹框 -->
            <select-dialog />
            <!-- 个别模块需要打开表单 -->
            <!-- <Basicform v-if="showForm" :title="formTitle" :win-width="moduleInfoT.winWidth" :win-height="moduleInfoT.winHeight" :module-code="moduleInfoT.moduleCode" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
        <template #default="slotProps">
          <busi-form ref="busiform" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfoT" />
        </template>
</Basicform> -->
            <!-- 工作报告的分享 -->
            <!-- <button v-show="showShare" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <!-- 工作报告回复 -->
            <!-- <replyDiaLog ref="repForm" :replay-vo="replayVo" :parent-vo="parentVo" /> -->
        </div>
    </div>
</template>

<script>
// import otherInfo from './components/otherInfo.vue'
// import replyDiaLog from './components/replyDiaLog.vue'
// import BasicInfoForm from './components/basic-info-form.vue'
// import RenzhiInfoForm from './components/renzhi-info-form.vue'
// import WorkExperienceForm from './components/work-experience-form.vue'
// import OtherInfoForm from './components/other-info-form.vue'
// 基本信息
import ArchiveInfo from './components/ArchiveInfo.vue'
// 任职信息
import AppointmnetInfos from './components/AppointmnetInfos.vue'
// 调离信息
import TransferInfo from './components/TransferInfo.vue'
// 相关学历及职业技能证书
import CertificatesInfo from './components/CertificatesInfo.vue'
// 考核记录
// import ExamineRecord from './components/ExamineRecord.vue'
// 工作简历/成长记录
import workExperiences from './components/workExperiences.vue'
// 家庭成员
import FamilyMembers from './components/FamilyMembers.vue'
// 变动信息
import ArchiveChangeInfo from './components/ArchiveChangeInfo.vue'
// 人事合同
import ArchiveConInfos from './components/ArchiveConInfos.vue'
// 工资信息
import WageInfo from './components/WageInfo.vue'
// 请休假情况
import VacateInfo from './components/VacateInfo.vue'
export default {
    name: 'Archive',
    components: {
        ArchiveInfo,
        AppointmnetInfos,
        TransferInfo,
        CertificatesInfo,
        // ExamineRecord,
        workExperiences,
        FamilyMembers,
        ArchiveChangeInfo,
        ArchiveConInfos,
        WageInfo,
        VacateInfo
        // otherInfo, replyDiaLog,
        // BasicInfoForm,
        // RenzhiInfoForm,
        // WorkExperienceForm,
        // OtherInfoForm,
        // changeInfoList
    },
    props: {},
    data() {
        return {
            voId: '',
            moduleInfo: {},
            replayVo: {},
            parentVo: {},
            vo: {},
            canEdit: 0,
            fileList: [],
            showForm: false,
            show: false,
            formType: '',
            title: '',
            formUrl: '',
            showShare: false,
            newId: '',
            moduleInfoT: {},
            noEdit: '',
            btnDisabled: false,
            busiInfo: '人员档案信息',
            row: {},
            loginUser: this.$store.getters.loginUser,
            busiformBtns: [],
            formTitle: '',
            uploadFiles: [],
            formItem: {},
            addChangeUpdate: false,
            tableHeaderBgColor: '#f1f5fb!important',
            activeTabId: 'ArchiveInfo',
            urlT: process.env.VUE_APP_BASE_API
        }
    },
    computed: {},
    watch: {},
    created() {
        // this.$bus.on('cellClick1', this.cellClick)
        // this.$bus.on('addUploadFiles', this.addUploadFiles)
        console.log('this.$route.query.moduleInfo:', this.$route.query)
        this.moduleInfo = JSON.parse(this.$route.query.moduleInfo)
        if (this.$route.query.rowdata) {
            this.row = JSON.parse(this.$route.query.rowdata)
        }
        this.title = this.$route.query.title
        this.noEdit = this.$route.query.noEdit
        this.busiInfo = this.$route.query.busiInfo || this.busiInfo
        console.log(this.title, this.busiInfo, 'this.title, this.busiInfo')
        console.log(this.noEdit, 'this.noEdit')
        console.log(this.moduleInfo, 'this.moduleInfo')
        console.log(this.row, 'this.row')
        document.title = this.$route.query.title || '人事档案'
        window.addEventListener('beforeunload', (event) => {
            if (window.opener && window.opener.loadList) {
                window.opener.loadList()
            }
        })
    },
    beforeDestroy() {
        // this.$bus.off('cellClick1', this.cellClick)
        // this.$bus.off('addUploadFiles', this.addUploadFiles)
    },
    mounted() {
        this.vo = {}
        this.formUrl = this.$route.query.formUrl
        console.log(this.formUrl, 'this.formUrl')

        if (this.$route.query.canEdit) {
            this.canEdit = this.$route.query.canEdit
        }
        if (this.$route.query.voId) {
            this.voId = this.$route.query.voId
            this.getVo(this.voId, this.moduleInfo)
            if (this.$route.query.editShow === '1' || this.$route.query.title == '编辑-人事信息') {
                this.canEdit = 1
            } else {
                this.canEdit = 0
            }

            this.formType = 'update'
        } else if (JSON.stringify(this.row) !== '{}') {
            this.vo = this.row

            this.canEdit = 0
            this.$nextTick(() => {
                this.show = true
            })
        } else {
            this.getVo(null, this.moduleInfo)
            this.canEdit = 1
            this.formType = 'addNew'
        }
    },
    methods: {
        // initScroll() {
        //     var tabs = document.querySelectorAll('.tab-item')
        //     var sections = document.querySelectorAll('.table-gap')
        //     function updateTabs() {
        //         console.log('cccc', tabs, sections)
        //         var activeTab = null

        //         // 遍历每个section和tab，找到当前应该激活的tab
        //         for (var i = 0; i < sections.length; i++) {
        //             var sectionTop = sections[i].getBoundingClientRect().top
        //             if (sectionTop >= 0 && sectionTop <= window.innerHeight) {
        //                 // 如果section在视口中，则激活对应的tab
        //                 activeTab = tabs[i]
        //                 break
        //             }
        //         }

        //         // 清除所有tab的激活状态，并激活找到的tab
        //         tabs.forEach(function(tab) {
        //             tab.classList.remove('active')
        //         })
        //         if (activeTab) {
        //             activeTab.classList.add('active')
        //         }
        //     }
        //     const box = document.querySelector('#new-busi-form')
        //     // 监听滚动事件并更新tabs
        //     box.addEventListener('scroll', updateTabs)

        //     // 初始时也执行一次，确保页面加载时选中的tab是正确的
        //     updateTabs()
        // },
        // addUploadFiles(formItem, fileList) {
        //     this.formItem = formItem
        //     this.uploadFiles = fileList
        // },
        // onSelectStaffCompleted(selectedNodes, attr) {
        //     var selectedId = ''
        //     var _this = this
        //     const list = []
        //     // 部门id/名字 //人员id/名字
        //     for (var i = 0; i < selectedNodes.length; i++) {
        //         const newobj = {}
        //         const obj = selectedNodes[i]
        //         newobj.inquirerId = obj.personId
        //         newobj.inquirerName = obj.name
        //         newobj.inquirerDeptId = obj.orgId
        //         newobj.inquirerDeptName = obj.orgFullName.split('-')[1]
        //         list.push(newobj)
        //     }
        //     // 列分享及表单内分享
        //     selectedId = _this.vo.id
        //     // 调用后台接口
        //     _this.$http({
        //         method: 'post',
        //         url: '/gzbg/jobReport/reportShare',
        //         params: {
        //             reportIds: selectedId
        //         },
        //         data: list
        //     }).then((res) => {
        //         if (res.code === 'success') {
        //             _this.$message.success(res.message)
        //             setTimeout(() => {
        //                 location.reload()
        //             }, 500)
        //         } else {
        //             _this.$message.error(res.message)
        //         }
        //     })
        // },
        // reply() {
        //     this.$http({
        //         method: 'post',
        //         url: '/gzbg/reply/addNew'
        //     }).then((res) => {
        //         if (res.code === 'success') {
        //             this.replayVo = res.body.vo
        //             this.replayVo.reportId = this.vo.id
        //             this.$http({
        //                 method: 'get',
        //                 url: '/gzbg/jobReport/getById',
        //                 params: {
        //                     id: this.replayVo.reportId
        //                 }
        //             }).then(res => {
        //                 if (res.code === 'success') {
        //                     this.parentVo = res.body.vo
        //                     this.$refs.repForm.isShow = true
        //                 }
        //             })
        //         } else {
        //             this.$message.error(res.message)
        //         }
        //     })
        // },
        // shareItem() {
        //     document.querySelector('.xzry').click()
        // },
        // cellClick(row) {
        //     this.showForm = true
        //     this.formTitle = '年申记录'
        //     this.busiformBtns = [
        //         {
        //             id: 'btn_close',
        //             btnName: '关 闭',
        //             btnIcon: 'close',
        //             btnClick: 'closeDialog',
        //             btnPermission: '',
        //             btnType: ''
        //         }
        //     ]

        //     this.moduleInfoT.getByIdUrl = 'zzgl/certCheckRecord/getById'
        //     this.moduleInfoT.moduleCode = 'certCheckRecord'
        //     this.moduleInfoT.formTemplate = '#/dcontent/vuebusiform/W/zzgl.certCheckRecord.form1.vue?sysCode='
        //     this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfoT.formTemplate)
        //     this.$nextTick(() => {
        //         this.$bus.emit('openBusiform', this.moduleInfoT, row, 0, (res) => { })
        //     })
        // },
        reloadList() {
            if (this.formType === 'addNew') {
                location.href = location.href.replace('voId=', 'voId=' + this.newId)
            }
            setTimeout(() => {
                location.reload()
            }, 500)
        },
        submit(falg, callBack) {
            this.childComponentFormValidate(falg, callBack)
        },
        onBasicFormBeforeSubmit($scope, vo, defer) {
            defer.resolve(true)
        },
        onBasicFormSubmited($scope, callBack) {
            if (callBack) {
                callBack()
            }
        },

        childComponentFormValidate(falg, callBack) {
            var _this = this
            console.log('this:', this)
            this.formValidate(
                () => {
                    new Promise((resolve, reject) => {
                        // _this.$refs.ArchiveInfo.onBasicFormBeforeSubmit(_this, _this.vo, { resolve, reject })
                        _this.onBasicFormBeforeSubmit(_this, _this.vo, { resolve, reject })
                    })
                        .then((res) => {
                            _this.btnDisabled = true
                            let serveiceUrl = ''
                            let serveiceMethod
                            if (!_this.addChangeUpdate) {
                                serveiceUrl = this.formType === 'addNew' ? this.moduleInfo.insertUrl : this.moduleInfo.updateUrl
                                serveiceMethod = this.formType === 'addNew' ? 'POST' : 'PUT'
                            } else {
                                serveiceUrl = this.moduleInfo.updateUrl
                                serveiceMethod = 'PUT'
                            }
                            new Promise((resolve, reject) => {
                                _this
                                    .$http({
                                        url: serveiceUrl,
                                        method: serveiceMethod,
                                        data: _this.vo
                                    })
                                    .then((res) => {
                                        _this.btnDisabled = false
                                        if (res.code === 'success') {
                                            _this.$message.success(res.message)
                                            if (!_this.addChangeUpdate) {
                                                if (this.formType === 'addNew') {
                                                    _this.newId = res.body.vo.id
                                                }
                                            }
                                            // if (this.vo.idPhotoName) {
                                            //     this.$refs.ArchiveInfo.uploadfile()
                                            // }

                                            // 如果有附件上传
                                            let uploadAttach = []
                                            let array = []
                                            if (_this.$refs.ArchiveInfo.$refs.idPhoto) {
                                                uploadAttach = _this.$refs.ArchiveInfo.$refs.idPhoto.updateFileList
                                                _this.$refs.ArchiveInfo.$refs.idPhoto.updateFileList.forEach((item) => {
                                                    const fd = new FormData()
                                                    // fd.append('file', item.raw)
                                                    // fd.append('module', _this.moduleInfo.moduleCode)
                                                    // fd.append('attachsSize', item.size)
                                                    // fd.append('busiDataId', _this.vo.id)
                                                    // fd.append('attachsType', 'ATTACH')
                                                    // fd.append('attachsName', item.name)
                                                    // fd.append('uploadBy', _this.loginUser.personName)
                                                    // fd.append('uploadById', _this.loginUser.userId)

                                                    fd.append('file', item.raw)
                                                    fd.append('id', res.body.vo.id)
                                                    fd.append('dataField', 'idPhoto')
                                                    fd.append('nameField', 'certificatesName')
                                                    array.push(
                                                        this.$http({
                                                            method: 'PUT',
                                                            url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                                                            data: fd
                                                        })
                                                    )
                                                })
                                            }

                                            if (_this.$refs.CertificatesInfo.uploadAttachList && _this.$refs.CertificatesInfo.uploadAttachList.length > 0) {
                                                console.log(_this.$refs.CertificatesInfo.uploadAttachList, '_this.$refs.CertificatesInfo.uploadAttachList')

                                                uploadAttach.push(..._this.$refs.CertificatesInfo.uploadAttachList)
                                                _this.$refs.CertificatesInfo.uploadAttachList.forEach((item) => {
                                                    const fd = new FormData()
                                                    fd.append('file', item.raw)
                                                    fd.append('id', item.rowId)
                                                    fd.append('dataField', 'certificatesEnclosure')
                                                    fd.append('nameField', 'certificatesFileName')
                                                    array.push(
                                                        this.$http({
                                                            method: 'PUT',
                                                            url: 'rsgl/certificatesInfo/upload',
                                                            data: fd
                                                        })
                                                    )
                                                })
                                            }
                                            if (_this.$refs.ArchiveConInfos.uploadAttachList && _this.$refs.ArchiveConInfos.uploadAttachList.length > 0) {
                                                console.log(_this.$refs.ArchiveConInfos.uploadAttachList, '_this.$refs.ArchiveConInfos.uploadAttachList')

                                                uploadAttach.push(..._this.$refs.ArchiveConInfos.uploadAttachList)
                                                _this.$refs.ArchiveConInfos.uploadAttachList.forEach((item) => {
                                                    const fd = new FormData()
                                                    fd.append('file', item.raw)
                                                    fd.append('id', item.rowId)
                                                    fd.append('dataField', 'conFile')
                                                    fd.append('nameField', 'fileName')
                                                    array.push(
                                                        this.$http({
                                                            method: 'PUT',
                                                            url: 'rsgl/conInfo/upload',
                                                            data: fd
                                                        })
                                                    )
                                                })
                                            }
                                            if (uploadAttach.length > 0) {
                                                Promise.all(array).then((res) => {
                                                    if (res.length === uploadAttach.length) {
                                                        resolve()
                                                    }
                                                })
                                            } else {
                                                resolve()
                                            }
                                            // if (_this.uploadFiles.length > 0) {
                                            //     _this.uploadFiles.forEach(item => {
                                            //         const uploadingFile = item
                                            //         const config = {
                                            //             onUploadProgress: progressEvent => {
                                            //                 const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
                                            //                 uploadingFile.progress = complete
                                            //                 _this.$forceUpdate()
                                            //             }
                                            //         }
                                            //         let fieldUploadUrl = ''
                                            //         if (_this.formItem.downloadUrl !== undefined && _this.formItem.downloadUrl !== null && _this.formItem.downloadUrl !== '') {
                                            //             fieldUploadUrl = _this.formItem.downloadUrl.replace('/downloadById', '/upload').replace('/download', '/upload')
                                            //         }
                                            //         const nameField = this.formItem.nameField
                                            //         const dataField = this.formItem.propName
                                            //         this.$app.upload(fieldUploadUrl, item.raw, { 'id': _this.formItem.pid || this.vo.id, 'nameField': nameField, 'dataField': dataField }, config)
                                            //     })
                                            //     resolve()
                                            // } else {
                                            //     resolve()
                                            // }
                                        } else {
                                            _this.$message.error(res.message)
                                        }
                                    })
                            }).then((res) => {
                                if (falg) {
                                    if (callBack) {
                                        callBack(true)
                                    }
                                    _this.onBasicFormSubmited()
                                    _this.addChangeUpdate = true
                                    _this.close()
                                } else {
                                    _this.onBasicFormSubmited(_this, _this.reloadList)
                                }
                            })
                        })
                        .catch((error) => {
                            this.$message.error(error)
                        })
                },
                () => {
                    if (callBack) {
                        callBack(false)
                    }
                }
            )
        },
        close() {
            window.close()
        },
        edit(val) {
            this.show = false
            this.canEdit = val
            this.$nextTick(() => {
                this.show = true
            })
            this.$forceUpdate()
        },
        getVo(id, moduleInfo) {
            if (id) {
                this.$http({
                    method: 'get',
                    url: moduleInfo.getByIdUrl,
                    params: {
                        id: id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                    }
                    this.show = true
                })
            } else {
                this.$http({
                    method: 'post',
                    url: moduleInfo.addNewUrl
                }).then((res) => {
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        this.show = true

                        if (this.title === '人事档案') {
                            // this.vo.passenger.appointmnetInfos = []
                            // this.vo.passenger.workExperiences = []
                            // this.vo.passenger.certificatesInfos = []
                            // this.vo.passenger.conInfos = []
                            // this.vo.passenger.bankcardInfos = []
                        }
                    }
                })
            }
            // if (this.title === '人事档案') {
            //     this.fileList = {
            //         certificatesInfo: [],
            //         archiveInfo: []
            //     }
            // }
        },
        // handleHeaderTabClick(tabId) {
        //     this.activeTabId = tabId
        //     document.getElementById(tabId).scrollIntoView()
        // },
        handleHeaderTabClick(tabId) {
            this.activeTabId = tabId
            var container = document.getElementById('busiComponents')
            var targetElement = document.getElementById(tabId)

            if (container && targetElement) {
                // 滚动到 targetElement 的顶部
                // 注意：这里假设 container 是 targetElement 的滚动容器，并且 container 的 position 不是 static
                // 如果 container 的 position 是 static，则可能需要调整计算方式
                container.scrollTop = targetElement.offsetTop - 80

                // 如果 targetElement 上面有 padding 或 border，您可能需要从 offsetTop 中减去这些值
                // 但这通常不需要，因为 offsetTop 已经考虑了这些

                // 如果需要平滑滚动，可以添加平滑滚动的逻辑
            }
        }
    }
}
</script>
<style scoped lang="scss">
/deep/.el-table__body-wrapper::-webkit-scrollbar {
    height: 8px;
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 12px;
    /*滚动条的背景区域的圆角*/
}

/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 12px;
    /*滚动条的圆角*/
    background-color: #f5f5f5;
    /*滚动条的背景颜色*/
}

/deep/.el-form .el-table__body .tdlbl {
    text-align: left !important;
    background: unset !important;
}

#new-busi-form {
    height: 100%;
    background: #f0f2f5;
    min-width: 1360px;

    .new-head {
        height: 68px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        // padding-bottom: 10px;
        background: white;
        align-items: center;

        .head-left {
            display: flex;
            align-items: center;

            img {
                width: 44px;
                height: 44px;
            }

            .head-left-info {
                margin-left: 10px;

                .head-title {
                    font-size: 14px;
                    color: #333;
                    font-weight: 600;
                    padding-top: 10px;
                    padding-left: 5px;
                }
            }
        }

        .head-right {
            min-width: 400px;
            text-align: right;
        }
    }

    .busi-box {
        height: calc(100% - 68px);
        overflow: auto;
        // padding-top: 20px;
        // padding-left: 10px;
        padding: 20px;

        .busi-content {
            width: 1200px;
            padding-bottom: 20px;
            background: white;
            min-height: calc(100vh - 108px);
            margin: 0px auto;
            box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);

            .title-info {
                height: 93px;
                text-align: center;
                line-height: 93px;
                font-size: 24px;
                color: #000000;
            }

            .busi-components {
                padding: 0 100px;
            }
        }
    }

    /* 设置滚动条thumb（轨道）的颜色 */
    .busi-box::-webkit-scrollbar {
        background-color: #f0f2f5;
        width: 8px;
    }

    /* 设置滚动条thumb（滑块）的颜色 */
    .busi-box::-webkit-scrollbar-thumb {
        border-radius: 12px;
    }

    /* 设置滚动条hover时thumb的颜色 */
    .busi-box:hover.busi-box::-webkit-scrollbar-thumb {
        background-color: #d5d6d8;
    }

    /deep/.el-table .el-table__header-wrapper .el-table__header thead th {
        background: #f2f5fb !important;
    }
}
</style>

<style scoped lang="scss">
@import '@/wapp/common/styles/variables.module.scss';

.table-gap {
    // margin-top: 20px;
    margin-bottom: 20px;
}

.header-tab {
    display: flex;
    // margin-top: 10px;
    height: 38px;
    line-height: 38px;

    .tab-item {
        position: relative;
        margin-right: 10px;
        padding: 0 5px;
        font-weight: 600;
        // color: #666;
        color: #333;
        display: inline-block;
        width: auto;
        white-space: nowrap;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        cursor: pointer;
    }

    .active {
        position: relative;
        color: var(--subjectColor);

        &::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0px;
            width: 100%;
            height: 3px;
            background: var(--subjectColor);
        }
    }
}

// /deep/ .tdw13{
//     width: 13% !important;
//     text-align: right;
// }
// /deep/ .tdw20 {
//     width: 20% !important;
// }
/deep/.el-form .el-table__body td.tdw20 {
    width: 20% !important;
}

/deep/.el-form .el-table__body td.tdw13 {
    width: 13% !important;
}

/deep/ .el-form .el-table__body {
    min-width: 100%;
}
</style>
